import { useState, useContext } from "react";
import styles from "../Import/ImportModal.module.css";
import SheetProduct from '../../../assets/sheet_product.png'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { TemplateContext } from '../../../context/TemplateContext';
import { create } from "../../../hooks/Template";

function Modal({ closeModal }) {
  const { addTemplate } = useContext( TemplateContext );
  const [templateName, setTemplateName] = useState("")
  const [columns, setColumns] = useState({
    columnA: "",
    columnB: "",
    columnC: "",
    columnD: "",
  });
  const [lineStart, setLineStart] = useState("");
  const handleInputChange = (e, columnKey) => {
    const value = e.target.value.toUpperCase(); // Converte para letras maiúsculas
    if (/^[A-Z]{0,3}$/.test(value)) { // Permite apenas até 2 letras
      setColumns({ ...columns, [columnKey]: value });
    }
  };

  const isFormValid = templateName && columns.columnA && columns.columnB && columns.columnC && columns.columnD && lineStart;
  const onSaveClick = async (e) => {
    if (isFormValid) {
      const templateData = {
        templateName,
        barcode: columns.columnA,
        productName: columns.columnB,
        manufacturer: columns.columnC,
        group: columns.columnD,
        line: parseInt(lineStart), 
      };
    const response = await create( templateData );
    if (response) {
      addTemplate(true)
      closeModal();
    } else {
      addTemplate(false)
      toast.error("Erro ao salvar o Template de importação de produtos.")
    }
    } else {
      toast.error("Por favor, preencha todos os campos antes de salvar.");
    }
  };
  return (
    <div className={styles.modalBackground}>
      <ToastContainer />
      <div className={styles.modalContainer}>
        <div className={styles.content}>
          <h2>Importação de Produtos</h2>
          <h4>Exemplo</h4>
          <div className={styles.inputsRow}>
            <div className={styles.inputGroup}>
              <label htmlFor="barcode">Código de Barras</label>
              <input id="barcode" type="text" placeholder="A" disabled />
            </div>
            <div className={styles.inputGroup}>
              <label htmlFor="productName">Nome do Produto</label>
              <input id="productName" type="text" placeholder="B" disabled/>
            </div>
            <div className={styles.inputGroup}>
              <label htmlFor="manufacturer">Fabricante</label>
              <input id="manufacturer" type="text" placeholder="C" disabled/>
            </div>
            <div className={styles.inputGroup}>
              <label htmlFor="group">Grupo</label>
              <input id="group" type="text" placeholder="D" disabled/>
            </div>
            <div className={styles.inputGroup}>
              <label htmlFor="line">Linha</label>
              <input id="line" type="text" placeholder="1" disabled/>
            </div>
          </div>
          <img src={SheetProduct} alt="Exemplo de planilha de importação"/>
          <h4>Nome do template</h4>
          <input className={styles.inputTemplateName}
            type="text"
            placeholder="Digite o nome do template"
            value={ templateName }
            onChange={(e) => setTemplateName(e.target.value)}
            />
          <h4>Parâmetros</h4>
          <table className={styles.parametersTable}>
            <thead>
              <tr>
                <th>Código de Barras</th>
                <th>Nome do Produto</th>
                <th>Fabricante</th>
                <th>Grupo</th>
                <th>Linha</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <input
                    type="text"
                    placeholder="Coluna (ex: A)"
                    value={columns.columnA}
                    onChange={(e) => handleInputChange(e, "columnA")}
                  />
                </td>

                <td>
                  <input
                    type="text"
                    placeholder="Coluna (ex: B)"
                    value={columns.columnB}
                    onChange={(e) => handleInputChange(e, "columnB")}
                  />
              </td>

                <td>
                  <input
                    type="text"
                    placeholder="Coluna (ex: C)"
                    value={columns.columnC}
                    onChange={(e) => handleInputChange(e, "columnC")}
                  />
                </td>

                <td>
                  <input
                    type="text"
                    placeholder="Coluna (ex: D)"
                    value={columns.columnD}
                    onChange={(e) => handleInputChange(e, "columnD")}
                  />
                </td>

                <td>
                  <input 
                    type="number" 
                    placeholder="Linha Inicial (ex: 1)"
                    value={ lineStart }
                    onChange={(e) => setLineStart(e.target.value)}
                    />
                </td>

              </tr>
            </tbody>
          </table>
        </div>
        <div className={styles.buttonContent}>
          <button className={styles.buttonConfirm} onClick={ onSaveClick }>Salvar</button>
          <button onClick={ closeModal } className={styles.buttonCancel}>
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}

export default Modal;
